import { useState } from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { FileTypeCategory, UploadValue } from 'modules/trainings/components/Files/types'
import { formatFileSize } from 'modules/trainings/components/Files/utils'

import Dropper from './Dropper'
import { UploadResult } from './UploadResult'

export default function Uploader({
  fileTypes,
  onUpload,
  description,
}: {
  fileTypes: FileTypeCategory[]
  description: string
  onUpload(upload: UploadValue): void
}) {
  const [file, setFile] = useState<File>()
  const [error, setError] = useState<string>()

  function handleError(errorMessage: string) {
    setFile(undefined)
    setError(errorMessage)
  }

  if (!file) {
    return (
      <>
        <Dropper
          error={Boolean(error)}
          fileTypes={fileTypes}
          onDrop={(result) => {
            if (result.type === 'error') {
              handleError(result.error)
              return
            }
            try {
              setFile(result.file)
              onUpload({ file: result.file })
            } catch (uploadError: unknown) {
              handleError(i18n.t('trainings.trainings_files_modal.failed_to_upload'))
            }
          }}
          description={description}
        />
        {error && (
          <Text color="radicalRed1000" size="200">
            {error}
          </Text>
        )}
      </>
    )
  }

  return (
    <UploadResult
      onDelete={() => {
        setFile(undefined)
      }}
      file={file}
    >
      <Text size="200">
        {`${i18nDateToString(new Date(file.lastModified), 'ui_short_with_time')} ${formatFileSize(
          file.size
        )}`}
      </Text>
    </UploadResult>
  )
}
